import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    brand: {
      50: '#f5e6ff',
      100: '#dbb8ff',
      200: '#c18aff',
      300: '#a75cff',
      400: '#8e2eff',
      500: '#7500e6',
      600: '#5c00b4',
      700: '#430082',
      800: '#2a0051',
      900: '#120021',
    },
    midnight: {
      50: '#e6eeff',
      100: '#b8cfff',
      200: '#8ab0ff',
      300: '#5c91ff',
      400: '#2e72ff',
      500: '#0049e6',
      600: '#0039b4',
      700: '#002982',
      800: '#001a51',
      900: '#000b21',
    },
    whatsapp: {
      50: '#dffeef',
      100: '#b9f5d0',
      200: '#90edb3',
      300: '#65e495',
      400: '#3cdc78',
      500: '#25d366',
      600: '#20b356',
      700: '#1a8f45',
      800: '#146c34',
      900: '#0d4a23',
    }
  },
  fonts: {
    heading: 'Inter, system-ui, sans-serif',
    body: 'Inter, system-ui, sans-serif',
  },
  components: {
    Button: {
      variants: {
        solid: {
          bg: 'brand.500',
          color: 'white',
          _hover: {
            bg: 'brand.600',
          },
        },
        outline: {
          borderColor: 'brand.500',
          color: 'brand.500',
          _hover: {
            bg: 'brand.50',
          },
        },
        ghost: {
          color: 'gray.400',
          _hover: {
            bg: 'whiteAlpha.200',
          },
        },
      },
    },
    Menu: {
      baseStyle: {
        list: {
          bg: 'gray.800',
          borderWidth: '1px',
          borderColor: 'whiteAlpha.200',
          boxShadow: 'lg',
          minW: '200px',
          py: 2,
          zIndex: 'dropdown',
        },
        item: {
          bg: 'transparent',
          color: 'gray.200',
          fontSize: 'sm',
          fontWeight: 'medium',
          px: 4,
          py: 2.5,
          transition: 'all 0.2s',
          _hover: {
            bg: 'whiteAlpha.200',
            color: 'white',
          },
          _focus: {
            bg: 'whiteAlpha.200',
            color: 'white',
          },
        },
        divider: {
          borderColor: 'whiteAlpha.200',
          my: 2,
        },
        button: {
          bg: 'transparent',
          color: 'gray.400',
          _hover: {
            bg: 'whiteAlpha.200',
            color: 'white',
          },
          _active: {
            bg: 'whiteAlpha.300',
          },
        },
      },
    },
    Modal: {
      baseStyle: {
        overlay: {
          bg: 'blackAlpha.700',
          backdropFilter: 'blur(8px)',
        },
        dialog: {
          bg: 'gray.800',
          borderRadius: 'xl',
          borderWidth: '1px',
          borderColor: 'whiteAlpha.200',
          boxShadow: 'xl',
          color: 'white',
        },
        header: {
          px: 6,
          py: 4,
          fontSize: 'xl',
          fontWeight: 'bold',
          borderBottomWidth: '1px',
          borderColor: 'whiteAlpha.200',
        },
        closeButton: {
          top: 4,
          right: 4,
          color: 'gray.400',
          _hover: {
            bg: 'whiteAlpha.200',
            color: 'white',
          },
        },
        body: {
          px: 6,
          py: 6,
        },
        footer: {
          px: 6,
          py: 4,
          borderTopWidth: '1px',
          borderColor: 'whiteAlpha.200',
        },
      },
      sizes: {
        xs: {
          dialog: { maxW: '320px' }
        },
        sm: {
          dialog: { maxW: '384px' }
        },
        md: {
          dialog: { maxW: '448px' }
        },
        lg: {
          dialog: { maxW: '512px' }
        },
        xl: {
          dialog: { maxW: '576px' }
        },
        '2xl': {
          dialog: { maxW: '672px' }
        },
        '3xl': {
          dialog: { maxW: '768px' }
        },
        '4xl': {
          dialog: { maxW: '896px' }
        },
        'full': {
          dialog: { maxW: '100vw', minH: '100vh' }
        },
      },
    },
  },
  styles: {
    global: {
      body: {
        bg: 'gray.900',
        color: 'white',
      },
    },
  },
});

export default theme;